var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height py-3 py-md-10"},[_c('v-container',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.terms_of_service)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }